import { createElement, FC } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import rtlDetect from 'rtl-detect';
import { ToastContainer } from '@ebsco-ui/ebsco-ui';

import { Footer } from '@app/components';
import { useAppLocale } from '@app/hooks';
import { Route } from '@app/constants';

import { PageBottomControls } from './PageBottomControls';
import { Header } from './Header';

import css from './NavigationLayout.module.scss';

export const NavigationLayout: FC = () => {
  const { locale } = useAppLocale();
  const { pathname } = useLocation();

  const isAdvancedSearchRoute = pathname === Route.advancedSearch;

  const getMainWrapper = () => {
    const isSearchResultsPage = pathname === Route.search;
    const isInstanceDetailsPage = Boolean(
      matchPath(Route.instanceDetails, pathname)
    );

    return createElement(
      isSearchResultsPage || isInstanceDetailsPage ? 'div' : 'main',
      { className: css.mainWrapper, 'data-focus': 'focusedNode', tabIndex: -1 },
      <Outlet />
    );
  };

  return (
    <>
      <Header isSearchVisible={!isAdvancedSearchRoute} />
      {getMainWrapper()}
      <div className={css.pageButtonsWrapper}>
        <PageBottomControls />
      </div>
      {!isAdvancedSearchRoute && <Footer />}
      <ToastContainer rtl={rtlDetect.isRtlLang(locale)} />
    </>
  );
};
